export function buildUserUpdateRequest(formDetail, accessDetail) {
    if (formDetail.role !== "PROPERTY_MANAGER" || !accessDetail) {
        return formDetail;
    }
    return {
        ...formDetail,
        agency_cos_customer_id: accessDetail.agency_cos_customer_id,
        property_access_mode: accessDetail.mode,
        property_ids: accessDetail.property_ids || []
    };
}
